<template>
  <v-row justify="center">
    <v-dialog
      v-model="isVisible"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="465"
      persistent
      scrollable
    >
      <v-card color="brand-card-bg">
        <v-toolbar
          color="brand-card-bg"
          flat
          height="80"
          max-height="80"
        >
          <v-avatar>
            <v-icon x-large>
              {{ vModel?.type === 'email' ? 'mdi-email-edit' : 'mdi-cellphone-message' }}
            </v-icon>
          </v-avatar>

          <v-toolbar-title class="pl-3">
            <div class="brand-text-title brand-green-dark--text">
              {{ vModel?.type === 'email' ? $t('Otp.Toolbar.Title.Email') : $t('Otp.Toolbar.Title.Phone') }}
            </div>
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            class="ma-0"
            color="brand-green-dark"
            icon
            large
            outlined
            style="background-color: white;"
            @click="closeDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider class="mx-4 brand-green-dark" />

        <v-card-text class="pa-0 px-1 text-body brand-green-dark--text">
          <v-container fluid>
            <v-row dense>
              <v-col cols="12">
                <div class="mb-2">
                  {{ vModel?.type === 'sms' ? $t('Otp.Title.Phone') : $t('Otp.Title.Email') }}
                </div>

                <v-otp-input
                  v-if="vModel"
                  v-model="vModel.otp"
                  color="brand-primary"
                  hide-details
                  length="6"
                  type="number"
                  @finish="onOtpValidate"
                />

                <div
                  v-if="parseInt(otpProgress.minute) || parseInt(otpProgress.second)"
                  class="text-end"
                >
                  {{ $t('Otp.ExpiresIn') }} {{ `${otpProgress.minute}:${otpProgress.second}` }}
                </div>

                <v-alert
                  v-if="otpError"
                  class="mt-4 caption"
                  dense
                  type="error"
                >
                  {{ otpError }}
                </v-alert>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider />

        <v-card-actions class="px-4 py-2 brand-text-title">
          <v-spacer />
          <v-btn
            class="brand-primary--text text--darken-1"
            outlined
            text
            @click="closeDialog"
          >
            {{ $t('Common.Button.Cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

import OtpDialogMixin from '@/theme/default/components/common/OtpDialog.js'

export default {
  name  : 'OtpDialog',
  mixins: [OtpDialogMixin]
}
</script>

<style scoped src="@/theme/default/components/common/OtpDialog.css"></style>

<style scoped>
</style>
